import {isDefined} from '@ls/js-utils';
import {immerable} from 'immer';
import CalcType from 'state/Constants/CalcType';
import ScaleType from 'state/Constants/ScaleType';
import scope from './scope';

export const getDefault = () => new RatingDefinition({
  ratingId: 'defaultRating',
  analytic: 'qualityRatingNumeric',
  isText: true,
  isNumeric: false,
  calcType: CalcType.Account,
  scaleType: ScaleType.Contribution
});

export default class RatingDefinition {
  [immerable] = true;

  constructor(props) {
    const {ratingId, analytic, calcType, scaleType, isText, isNumeric} = props;
    this.ratingId = ratingId;
    this.analytic = analytic; //ratings are just analytics under the hood
    this.calcType = calcType;
    this.scaleType = scaleType;
    this.isText = isText;
    this.isNumeric = isNumeric;
  }

  get complete() {
    return isDefined(this.ratingId) && (this.isText || this.isNumeric)
  }
  get key() {
    return `${scope} - ${this.ratingId}, ${this.calcType}, ${this.scaleType}`
  }
}